import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Users, Sparkles } from "lucide-react";
import { demoEvent } from "@/data/tourDemoData";

export const DemoRSVPFlow = () => {
  const [buddyChecked, setBuddyChecked] = useState(false);
  const [showSparkle, setShowSparkle] = useState(false);

  useEffect(() => {
    // Auto-toggle the buddy checkbox after a delay for demo effect
    const timer = setTimeout(() => {
      setBuddyChecked(true);
      setShowSparkle(true);
      setTimeout(() => setShowSparkle(false), 1000);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Card className="w-full max-w-sm mx-auto p-5 bg-card animate-scale-in">
      <div className="space-y-4">
        <div className="text-center pb-3 border-b border-border">
          <h3 className="font-semibold text-foreground">{demoEvent.title}</h3>
          <p className="text-sm text-muted-foreground">{demoEvent.date}</p>
        </div>

        <div 
          className={`relative flex items-start gap-3 p-4 rounded-xl border-2 transition-all duration-300 ${
            buddyChecked 
              ? 'border-primary bg-primary/10' 
              : 'border-border bg-muted/30'
          }`}
        >
          {showSparkle && (
            <div className="absolute -top-2 -right-2 animate-sparkle">
              <Sparkles className="w-6 h-6 text-yellow-500" />
            </div>
          )}
          
          <Checkbox 
            id="demo-buddy" 
            checked={buddyChecked}
            onCheckedChange={(checked) => setBuddyChecked(checked as boolean)}
            className="mt-1"
          />
          <div className="flex-1">
            <Label 
              htmlFor="demo-buddy" 
              className="font-medium text-foreground cursor-pointer flex items-center gap-2"
            >
              <Users className="w-4 h-4 text-primary" />
              Find me a Buddy
            </Label>
            <p className="text-sm text-muted-foreground mt-1">
              Get matched with someone attending this event
            </p>
          </div>
        </div>

        <Button 
          className="w-full font-semibold"
          size="lg"
        >
          RSVP to Event
        </Button>

        <p className="text-xs text-center text-muted-foreground">
          {buddyChecked ? "✨ We'll match you with a buddy!" : "Toggle above to find a buddy"}
        </p>
      </div>
    </Card>
  );
};
